// extracted by mini-css-extract-plugin
module.exports = {"container":"QsrDate_container__EyYwM","icon":"QsrDate_icon__ObsuG"};